import React from 'react';
import VocationStartLogo from './img/vocation_start_logo.png';
import VocationJuniorLogo from './img/vocation_junior_logo.png';
import VocationOneLogo from './img/vocation_one_logo.png';
import {
  Form,
  FormInput,
  SchoolInfoWrapper,
  Row,
  Col
} from './finished.styles';

const MessageBox = props => {
  const { SKU, campaign, user } = props;
  const userLastname = user?.lastname;
  const userName = user?.name;
  const userComplete =
    [userLastname, userName].some(Boolean) &&
    `${userLastname ? `${userLastname}, ` : ''}${userName}`;

  return (
    <Row>
      {SKU === 'VOCATION_ONE' && <VocationOneIntro />}
      {SKU === 'VOCATION_JUNIOR' && <VocationJuniorIntro />}
      {SKU === 'VOCATION_START' && <VocationStartIntro />}
      <Col>
        <Form onSubmit={() => {}}>
          <FormInput>
            <SchoolInfoWrapper>
              <div>
                {userComplete || campaign.organization || campaign.title}
              </div>
            </SchoolInfoWrapper>
          </FormInput>
          <FormInput>
            <p>Tu respuesta ya fue registrada con éxito anteriormente.</p>
            <p>No es necesario que haga nada más.</p>
          </FormInput>
        </Form>
      </Col>
      <div>
        <div className='bl' />
        <div className='tr' />
      </div>
    </Row>
  );
};
export default MessageBox;

const VocationOneIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationOneLogo} alt='vocation one logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation One</strong>.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);

const VocationJuniorIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationJuniorLogo} alt='vocation junior logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Junior</strong>.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);

const VocationStartIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationStartLogo} alt='vocation start logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Start</strong>.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);
